import { Label } from '@cian/ui-kit';
import * as React from 'react';

import type { IEtazhiBlackFridayDiscountColorsConfig } from 'shared/types/etazhiBlackFriday';

import styles from './EtazhiBlackFridayPriceDiscount.css';

interface IProps {
  oldPrice: string;
  percent: string;
  colors: IEtazhiBlackFridayDiscountColorsConfig;
}

export const EtazhiBlackFridayPriceDiscount: React.FC<IProps> = ({ oldPrice, percent, colors }) => {
  return (
    <span className={styles['price-discount']}>
      <Label background={colors.bgColor} color={colors.color}>
        {percent}
      </Label>
      <span className={styles['old-price']} style={{ textDecorationColor: `var(--${colors.strikethroughColor})` }}>
        {oldPrice}
      </span>
    </span>
  );
};
